// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1hC-j","inner":"Footer_inner__10Xj3"};